import React, { useEffect } from "react";
import { connect } from "react-redux";

import { OutOfCadenceEntity } from "@mapmycustomers/shared/types/entity/activities/OutOfCadenceEntity";
import ActivitySuggestion from "@mapmycustomers/shared/types/entity/ActivitySuggestion";

import CadenceModal from "@app/component/activity/CadenceModal/CadenceModal";
import { RootState } from "@app/store/rootReducer";

import { areOutOfCadenceEntitiesLoading, getOutOfCadenceEntities } from "../../store";
import { fetchOutOfCadenceEntities } from "../../store/actions";

interface Props {
  entities: OutOfCadenceEntity[];
  loading?: boolean;
  onFetchEntities: (payload: { startAt: string }) => void;
  onHide: () => void;
  suggestion: ActivitySuggestion;
}

const ActivityCadenceModal: React.FC<Props> = ({
  entities,
  loading,
  onFetchEntities,
  onHide,
  suggestion,
}) => {
  useEffect(() => {
    onFetchEntities({ startAt: suggestion.startAt });
  }, [onFetchEntities, suggestion]);

  return (
    <CadenceModal
      cadencedAt={suggestion.startAt}
      entities={entities}
      loading={loading}
      onHide={onHide}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  entities: getOutOfCadenceEntities(state),
  loading: areOutOfCadenceEntitiesLoading(state),
});

const mapDispatchToProps = {
  onFetchEntities: fetchOutOfCadenceEntities.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivityCadenceModal);
